import { render } from "./CategoryImage.vue?vue&type=template&id=35df0d84&lang=pug"
import script from "./CategoryImage.vue?vue&type=script&lang=js"
export * from "./CategoryImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__